import type { useAuth as useAuthKit } from '@workos-inc/authkit-react';
import { createContext } from 'react';

import type { MeResponse } from '@noma-eco/platform/schema';

/**
 * Auth surface the dev-token bypass provides. Mirrors the fields the SPA
 * consumes from AuthKit so `useAuth` consumers stay agnostic to which
 * provider is mounted.
 */
export type DevAuthContextValue = {
  user: MeResponse['user'] | null;
  isLoading: boolean;
  // Accepts the same `{ forceRefresh? }` shape AuthKit's getAccessToken takes
  // so the AccessTokenBridge can pass options through uniformly. The dev path
  // has no refresh — the option is ignored and the same stub token is
  // returned every call.
  getAccessToken: (options?: { forceRefresh?: boolean }) => Promise<string>;
  signIn: (options?: { organizationId?: string }) => void;
  signOut: () => void;
  switchToOrganization: (opts: { organizationId: string }) => Promise<void>;
};

/**
 * What `useAuth` resolves to: either the dev-token bypass shape or AuthKit's
 * own context value. `AppProviders` mounts exactly one of the two providers;
 * consumers read this union through `useAuth` without caring which.
 */
export type AuthContextValue = DevAuthContextValue | ReturnType<typeof useAuthKit>;

export const AuthContext = createContext<AuthContextValue | null>(null);
